<template>
    <div>
        <div class="dashboard-profile-pic collegeSide">
            <img v-bind:src="image" alt="" v-if="image">
            <img v-else src="/images/user_avatar.png">
            <label for="clogo-edit" class="edit-icon" v-if="this.$store.getters.getUserType != 'teacher'"><i class="fas fa-pencil-alt"></i></label>
        </div>
        <div v-if="this.$store.getters.getUserType != 'teacher'">
            <div class="pic-details">
                <input type="file" id="clogo-edit" class="file" @change="onPhotoUploaded">
            </div>
<!--            <div class="pd-sec-box">-->
<!--                <i class="fas fa-user-tie"></i> Name-->
<!--                <p v-html="name"></p>-->
<!--            </div>-->
<!--            <div class="pd-sec-box">-->
<!--                <i class="fas fa-mobile-alt"></i> Phone-->
<!--                <p>{{phone}}</p>-->
<!--            </div>-->
<!--            <div class="pd-sec-box">-->
<!--                <i class="fas fa-envelope"></i> Email-->
<!--                <p>{{email}}</p>-->
<!--            </div>-->
            <div class="pd-sec-box tooltip-main margin-top-20">
                <i class="fas fa-link"></i> <span>Invitation Link</span> <i class="far fa-copy copy-to-clipboard" title="Tap to Copy"
                                                               v-on:click="copyToClipboard($event)"></i>
                <a href="javascript:;">https://www.myecampus.in/signup?ref={{ref_code}}</a>
                <span class="tooltiptext tooltip-bottom">Share link with your Students to invite them on the Platform</span>
            </div>
        </div>
        <div v-else>
<!--            <div class="pd-sec-box">-->
<!--                <i class="fas fa-user-tie"></i>-->
<!--                <p v-html="name"></p>-->
<!--            </div>-->
<!--            <div class="pd-sec-box">-->
<!--                <i class="fas fa-university"></i>-->
<!--                <p v-html="college"></p>-->
<!--            </div>-->
            <div class="pd-sec-box tooltip-main">
                <i class="fas fa-link"></i> <span>Invitation Link</span> <i class="far fa-copy copy-to-clipboard" title="Tap to Copy"
                                                               v-on:click="copyToClipboard($event)"></i>
                <a href="javascript:;">https://www.myecampus.in/signup?ref={{ref_code}}</a>
                <span class="tooltiptext tooltip-bottom">Share link with your Students to invite them on the Platform</span>
            </div>
        </div>
        <div class="divider"></div>
        <div class="vertical-navi">
            <ul class="nav flex-column" v-if="this.$store.getters.getUserType != 'teacher'">
                <li class="nav-item" v-on:click="setActive('dashboard')">
                    <router-link to="/dashboard" class="nav-link" :class="{active: isActive('dashboard')}">Dashboard
                    </router-link>
                </li>
                <li class="nav-item" v-on:click="setActive('jobs')" v-if="this.$store.getters.getPreferences['show_jobs']">
                    <router-link to="/dashboard/jobs" class="nav-link" :class="{active: isActive('jobs')}">Approved
                        Jobs
                    </router-link>
                </li>
                <li class="nav-item" v-on:click="setActive('internships')" v-if="this.$store.getters.getPreferences['show_internships']">
                    <router-link to="/dashboard/internships" class="nav-link"
                                 :class="{active: isActive('internships')}">Approved Internships
                    </router-link>
                </li>
                <li class="nav-item" v-on:click="setActive('edit')">
                    <router-link to="/dashboard/edit" class="nav-link" :class="{active: isActive('edit')}">Edit
                        Profile
                    </router-link>
                </li>
                <li class="nav-item" v-on:click="setActive('preferences')" v-if="this.$store.getters.getUser['business_activity'] != 'School'">
                    <router-link to="/dashboard/preferences" class="nav-link"
                                 :class="{active: isActive('preferences')}">Preferences
                    </router-link>
                </li>
            </ul>
            <ul class="nav flex-column" v-else>
                <li class="nav-item" v-on:click="setActive('Quiz')" v-if="this.$store.getters.getUser['business_activity'] === 'School'">
                    <router-link to="/dashboard/quiz" class="nav-link" :class="{active: isActive('quiz')}">
                        Quiz</router-link>
                </li>
                <li class="nav-item" v-on:click="setActive('QuizCreate')" v-if="this.$store.getters.getUser['business_activity'] === 'School'">
                    <router-link to="/dashboard/create-quiz" class="nav-link" :class="{active: isActive('quiz-create')}">
                        Create Quiz
                    </router-link>
                </li>
                <li class="nav-item" v-on:click="setActive('edit')">
                    <router-link to="/dashboard/edit" class="nav-link" :class="{active: isActive('edit')}">Edit
                        Profile
                    </router-link>
                </li>
                <li class="nav-item" v-on:click="setActive('skill-up')">
                    <router-link to="/dashboard/my-desk" class="nav-link" :class="{active: isActive('skill-up')}">
                        My Desk
                    </router-link>
                </li>
            </ul>
            <div v-if="loggedIn">
                <ul class="account-btns float-none hide-sm" v-on:click="logoutClicked">
                    <li class="float-none"><i class="fas fa-sign-out-alt"></i> Logout</li>
                </ul>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import toastr from '../../public/js/toastr.js';
    import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";

    export default {
        data() {
            return {
                activeItem: window.location.pathname.split('/')[window.location.pathname.split('/').length - 1],
                name: '',
                email: '',
                phone: '',
                college: '',
                image: '',
                ref_code: '',
            }
        },
        mounted() {
            var t = this;
            var url = t.$store.getters.getDomain;
            if (this.$store.getters.getUserType == 'teacher') {
                var user = this.$store.getters.getUser;
                this.college = user['college'];
            }

            //request to get skills
            axios.post(`${url}api/v2/college-profile/org-data`, '', {headers: requestHeaders()}).then(function (response) {
                var data = response['data']['response']['detail'][0];
                t.image = data['logo'];
                t.name = data['name'];
                t.phone = data['phone'];
                t.email = data['email'];
                t.ref_code = data['referral_code'];
                t.$store.dispatch('setCollegeId', data['college_id']);
                t.$store.dispatch('setRefId', data['referral_code']);
                t.$parent.college_name = data['name'];
            });
        },
        computed: {
            changeImage() {
                return this.$store.getters.getImage;
            },
            loggedIn: function () {
                return this.$store.getters.getAuthState;
            }
        },
        watch: {
            changeImage(value) {
                var t = this;
                t.image = value;
            },
        },
        methods: {
            isActive: function (menuItem) {
                return this.activeItem === menuItem
            },
            setActive: function (menuItem) {
                return this.activeItem = menuItem
            },
            onPhotoUploaded(event) {
                showLoader();
                var t = this;
                var url = this.$store.getters.getDomain;
                this.uploadedPhoto = event.target.files[0];
                const fd = new FormData();
                fd.append('profile_image', this.uploadedPhoto, this.uploadedPhoto.name);
                axios.post(`${url}api/v2/college-profile/upload-logo`, fd, {
                    headers: requestHeaders(),
                    // onUploadProgress: uploadEvent => {
                    //     console.log('Upload Progress: ' + Math.round(uploadEvent.loaded/uploadEvent.total * 100) + "%")
                    // }
                })
                    .then(res => {
                        hideLoader();
                        if (res.status == 200) {
                            var image = res['data']['response']['logo'];
                            t.$store.dispatch("setImage", image);
                            toastr.success('Picture Uploaded Successfully', 'Success');
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })

            },
            copyToClipboard(event) {
                var element = event.currentTarget;
                var link = element.nextSibling.textContent;
                var temp = $("<input>");
                $("body").append(temp);
                temp.val(link).select();
                document.execCommand("copy");
                temp.remove();
                toastr.success('Copied to Clipboard', 'Copied');
            },
            logoutClicked() {
                this.$store.dispatch("setLoggedOut");
                toastr.success('Logging out soon', 'Logged Out');
                window.location.replace("/");
            },
        }
    }
</script>

<style scoped>
    .copy-to-clipboard {
        float: right;
        color: #555;
        cursor: pointer;
    }

    .pd-sec-box a {
        word-break: break-word;
        font-size: 16px;
    }
    .pd-sec-box > span{
        font-weight: 500;
    }
</style>